<template>
  <!-- Winning Margin -->
  <div class="template" v-if="newAllBetEvent.od[plytyp]">
    <template v-for="btype in btypes" v-if="newAllBetEvent.od[plytyp][btype]">
      <div data-template="template0" class="wrap-template template0">
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis" v-if="btype == 77 || btype == 78">
                {{ getTitleCaption() }}
                {{ sportAllBetLang['ALL_BET.SUBHEADER_WMR'] }}
              </span>
              <span class="ellipsis" v-else>
                {{ sportAllBetLang['ALL_BET.SUBHEADER_WM'] }}
              </span>
            </div>

            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <div class="handicap">
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_HWB1R']:sportAllBetLang['ALL_BET.LBL_HWB1']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_HWB1R'] }}
                          </span>
                          <span class="ellipsis-wrap"  v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_HWB1'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'h1'" :plyType="plytyp" :betType="btype" ref="teamhwb1" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_AWB1R']:sportAllBetLang['ALL_BET.LBL_AWB1']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_AWB1R'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_AWB1'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'a1'" :plyType="plytyp" :betType="btype" ref="teamawb1" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_HWB2R']:sportAllBetLang['ALL_BET.LBL_HWB2']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_HWB2R'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_HWB2'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'h2'" :plyType="plytyp" :betType="btype" ref="teamhwb23" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_AWB2R']:sportAllBetLang['ALL_BET.LBL_AWB2']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_AWB2R'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_AWB2'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'a2'" :plyType="plytyp" :betType="btype" ref="teamawb2" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_HWB3R']:sportAllBetLang['ALL_BET.LBL_HWB3']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_HWB3R'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_HWB3'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'h3'" :plyType="plytyp" :betType="btype" ref="teamhwb3" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_AWB3R']:sportAllBetLang['ALL_BET.LBL_AWB3']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"  v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_AWB3R'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_AWB3'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'a3'" :plyType="plytyp" :betType="btype" ref="teamawb3" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_HWB4RM']:sportAllBetLang['ALL_BET.LBL_HWB4M']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_HWB4RM'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_HWB4M'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'h4'" :plyType="plytyp" :betType="btype" ref="teamhwb4m" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1" :title="btype == 77 || btype == 78?sportAllBetLang['ALL_BET.LBL_AWB4RM']:sportAllBetLang['ALL_BET.LBL_AWB4M']">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" v-if="btype == 77 || btype == 78">
                            {{ sportAllBetLang['ALL_BET.LBL_AWB4RM'] }}
                          </span>
                          <span class="ellipsis-wrap" v-else>
                            {{ sportAllBetLang['ALL_BET.LBL_AWB4M'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'a4'" :plyType="plytyp" :betType="btype" ref="teamawb4m" :mode="'ab'" />
                  </div>
                </div>
              </div>

              <div class="handicap-item m-oe os-1 no_border_bottom" :title="sportAllBetLang['ALL_BET.LBL_AS']" v-if="btype != 77 && btype != 78">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" >
                            {{ sportAllBetLang['ALL_BET.LBL_AS'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'sd'" :plyType="plytyp" :betType="btype" ref="teamas" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1 no_border_bottom" :title="sportAllBetLang['ALL_BET.LBL_BB_AS']" v-else-if="btype == 77 || btype == 78">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" >
                            {{ sportAllBetLang['ALL_BET.LBL_BB_AS'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'sd'" :plyType="plytyp" :betType="btype" ref="teamas" :mode="'ab'" />
                  </div>
                </div>
              </div>

              <div class="handicap-item m-oe os-1 no_border_bottom" :title="sportAllBetLang['ALL_BET.LBL_NG']" v-if="btype != 77 && btype != 78">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:82%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap" >
                            {{ sportAllBetLang['ALL_BET.LBL_NG'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng'" :plyType="plytyp" :betType="btype" ref="teamng" :mode="'ab'" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().wmBetType, allBetMixin.data().rwmBetType, allBetMixin.data().wmrBetType, allBetMixin.data().rwmrBetType],
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
        if(this.mode=='ab'){
            this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
    },
    foldopenFirstEvent() {
        if(this.mode!='ab'){
            this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
    }
  },
  methods: {
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, wmBetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, wmBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, wmBetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, wmBetType, this.isSpecial)
    },
    getTitleCaption() {
      var a = ''
      var pt = ''
      var bt = ''
      var sCapt = ''
      if (this.plytyp == this.ftPlyType) {
        a = '_FT'
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H'
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H'
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP'
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP'
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP'
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') { /*** Set ***/
        a = '_' + this.pt[this.plytyp] + 'SET'
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') { /*** Game ***/
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME'
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS'
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS'
      }else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS'
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS'
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS'
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS'
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS'
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS'
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS'
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS'
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS'
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME'
      }

      // Play Type
      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a]

      
      return pt
    },
  },
  mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-wm.vue